module.exports = __webpack_public_path__ + "img/1456956869.eb6ae47d.jpg";